export default "__VITE_ASSET__1BPznoCY__"